import img1 from "../src/img/chicken-sandwich.jpg";
import img2 from "../src/img/grilled sandwich.jpg";
import img3 from "../src/img/egg sandwich.jpg";
import img4 from "../src/img/seafood sandwich.webp";
import img5 from "../src/img/nutella sandwich.webp";
import img6 from "../src/img/chees sandwich.jpg";
const Sandwichdata ={
    cardData : [
  
             {
                id: 1,
                imgSrc:img1 ,
                title: 'Chicken Sandwich.',
                cont : 'Chicken Sandwich. ,Grilled Chicken Sandwich, Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                 link : './Briyani',
                 rs : '140'
             },
             {
                 id: 2,
                 imgSrc:img2 ,
                 title: 'Grilled Chicken Sandwich',
                 cont : 'Chicken Sandwich. , Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                 rs : '180'
              } ,
              {
                 id: 3,
                 imgSrc:img3 ,
                 title: 'Egg Sandwich',
                 cont : 'Chicken Sandwich. ,Grilled Chicken Sandwich, Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                 rs : '80'
               } ,
              {
                 id: 4,
                 imgSrc:img4,
                 title: 'Seafood Sandwich',
                 cont : 'Chicken Sandwich. , Grilled Chicken Sandwich,Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                 rs : '220'
              },
              {
                id: 5,
                imgSrc:img5 ,
                title: 'Nutella Sandwich',  
                cont : 'Chicken Sandwich. ,Grilled Chicken Sandwich, Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                rs : '160'
             },
             {
                id: 6,
                imgSrc:img6 ,
                title: 'Grilled Cheese',  
                cont : 'Chicken Sandwich. ,Grilled Chicken Sandwich, Egg Sandwich, Seafood Sandwich. , Nutella Sandwich,Grilled Cheese',
                rs : '170'
             }
     ]
 };
 
 export default Sandwichdata;